import produce from 'immer';
import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';
import { Order } from '../models/order.model';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

export const updateOrderFromEvent = produce((draftState: any, action: any) => {
  if (draftState.data?.data) {
    draftState.data.data = draftState.data.data.map((anOrder: Order) => {
      if (anOrder.id === action.payload.id) {
        return {
          ...anOrder,
          ...action.payload,
        };
      }

      return anOrder;
    });
  }
});

export const list = (state: any = initialState.orders.list, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_ORDERS):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_ORDERS):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_ORDERS):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_ORDERS):
      return failedDefaults(state, action);
    case Type.UPDATE_ORDER_FROM_EVENT:
      return updateOrderFromEvent(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.list;
    default:
      return state;
  }
};

export const details = (state: any = initialState.orders.details, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_ORDERS_ID):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_ORDERS_ID):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_ORDERS_ID):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_ORDERS_ID):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.details;
    default:
      return state;
  }
};

export const create = (state: any = initialState.orders.create, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.CREATE_ORDER):
      return clearedDefaults(state);
    case State.actionRequested(Type.CREATE_ORDER):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CREATE_ORDER):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CREATE_ORDER):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.create;
    default:
      return state;
  }
};

export const cancel = (state: any = initialState.orders.cancel, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.CANCEL_ORDER):
      return clearedDefaults(state);
    case State.actionRequested(Type.CANCEL_ORDER):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CANCEL_ORDER):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CANCEL_ORDER):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.cancel;
    default:
      return state;
  }
};

export default combineReducers({
  list,
  details,
  create,
  cancel,
});
